export default {
  path: '/v5/library',
  name: 'V5_library',
  component: () => import('./LibraryPage.vue'),
};
